enum MoveDirections {
  UP,
  DOWN,
}

export { MoveDirections };
